import angular from 'angular';

import GoogleSsoBarComponent from './google-sso-bar-component';

const googleSsoBar = angular.module('googleSsoBar', []);
googleSsoBar.component('googleSsoBar', GoogleSsoBarComponent);

export default googleSsoBar.name;
